import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../../components/Button';
import SpouseLifeInsuranceModal from './SpouseLifeInsuranceModal';

const SpouseLifeInsuranceModalDemo = () => {
  const [showSpouseLifeInsuranceModal, setShowSpouseLifeInsuranceModal] =
    React.useState<boolean>(false);

  const handleShowSpouseLifeInsuranceModal = () =>
    setShowSpouseLifeInsuranceModal(true);
  const handleCloseSpouseLifeInsuranceModal = () =>
    setShowSpouseLifeInsuranceModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Spouse Life Insurance Modal</h4>
        <Button onMouseDown={handleShowSpouseLifeInsuranceModal}>
          Open Modal
        </Button>
        <SpouseLifeInsuranceModal
          showSpouseLifeInsuranceModal={showSpouseLifeInsuranceModal}
          handleCloseSpouseLifeInsuranceModal={
            handleCloseSpouseLifeInsuranceModal
          }
        />
      </Container>
    </Container>
  );
};

export default SpouseLifeInsuranceModalDemo;
